import * as React from 'react';

import { cn } from '@shared/lib/utils';

import type { IconProps } from './icon-types';

export function EyeIcon({ size = 20, className, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn('shrink-0', className)}
      aria-hidden="true"
      {...props}
    >
      <path d="M2.062 12.348a1 1 0 0 1 0-.696C3.423 7.585 7.36 4.5 12 4.5c4.64 0 8.577 3.085 9.938 7.152a1 1 0 0 1 0 .696C20.577 16.415 16.64 19.5 12 19.5c-4.64 0-8.577-3.085-9.938-7.152Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}
